export default __webpack_public_path__ + "static/media/V720_CoC.c392bbeb.pdf";